import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'

import { WarehouseGuard } from '@/features/warehouse/WarehouseGuard'
import { WarehouseShell } from '@/shared/layouts/WarehouseShell'

export function WarehouseAppLayout({ children }: { children?: ReactNode }) {
  return (
    <WarehouseGuard>
      <WarehouseShell>{children ?? <Outlet />}</WarehouseShell>
    </WarehouseGuard>
  )
}
